module.exports = __webpack_public_path__ + "static/media/aboutCouple.d78e6d8d.png";